import $ from 'jquery';
import { fabric } from '../common/fabric';
import { userinfo } from '../common/userinfo';
import { ui } from '../common/ui';
import { parts } from '../common/parts';
import { drawing } from '../common/drawing';
import { roleIdToRoleName } from '../../utilities/roleUtility';
import { client_keyplan } from './client_v2_keyplan';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import { getQueryStringParameter } from '../../utilities/commonUtil';

// 旧仕様で保存されているか
// BLDE_V2-20245で余白はなしに変更。以前は1000×750で保存しているので判定して同じ動作にする。
const isOldImageSize = () => {
  let naturalWidth = getQueryStringParameter('w');
  let naturalHeight = getQueryStringParameter('h');
  if (!naturalWidth || !naturalHeight) {
    const el = window.opener.document.getElementById('keyplan-image');
    naturalWidth = el.naturalWidth;
    naturalHeight = el.naturalHeight;
  }
  return Number(naturalWidth) === 1000 && Number(naturalHeight) === 750;
};

export const layoutInit = async function(keyplanUrl) {
  // 利用者情報を初期化
  let loginUserInfo = {
    field_id: sessionStorage.getItem('field_id'),
    field_name: null,
    company_id: null,
    user_id: localStorage.getItem('user_id'),
    user_name: null,
    user_type: roleIdToRoleName(localStorage.getItem('role_id')),
  };

  // パラメータとして日付を受け取る
  var currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);

  await userinfo.init(loginUserInfo);
  // UI要素を初期化
  ui.init(currentDate);

  // 部品設定を初期化
  parts.init();

  // Canvasを初期設定
  drawing.setCanvas('canvas');
  drawing._canvas.requestRenderAll();

  // `drawing.js`が`client_v2.js`に依存しており、当機能でも`drawing.js`を使いたいためダミーの`client`を初期化します
  client_keyplan.init();

  // drawingオブジェクトに client / places を指定する
  drawing.client = client_keyplan;
  drawing.places = null;
  drawing.split = null;

  // 外部ユーザーの場合は、ツールボタン群の操作をできないように非表示にする
  if (SessionStorageService.isExtraProxiLogin()) {
    ui.toolboxHide();
    $('.sys_keyplan_submit').addClass('element__hide');
  }
  // fabric.eg を初期化
  //  drawingの設定
  //  利用者情報の設定
  fabric.eg.init({
    drawing,
    userId: userinfo.getUserId(),
    userName: userinfo.getUserName(),
    companyName: userinfo.getUserCompanyName(),
  });
  const keyPlanImageObjEl = window.opener.document.getElementById(
    'keyplan-image-obj'
  );
  let canvasJson = keyPlanImageObjEl ? keyPlanImageObjEl.value : null;
  const canvasJsonTmp = window.opener.document.getElementById(
    'keyplan-image-obj-tmp'
  ).value;
  canvasJson = canvasJsonTmp ? canvasJsonTmp : canvasJson;
  if (canvasJson) {
    var canvasObjects = JSON.parse(
      canvasJson.replace(/=>nil/g, ':null').replace(/=>/g, ':')
    );
    $.each(canvasObjects.objects, function() {
      // this.selectable = false;
      // this.left += drawing.lefOffset;
    });
    drawing._canvas.loadFromJSON(canvasObjects, function() {
      drawing._canvas.requestRenderAll();
      // 印刷範囲の設定(白背景)
      const printRange = getPrintRangeFromCanvas(canvasObjects);
      if (printRange === null) {
        // 旧仕様の互換用
        // 1000×750で保存して表示時の印刷範囲が1000×650になっており余白に書き込みがあるかもしれないので引き継ぐ
        // 表示と保存時で高さが違う意図は不明
        if (isOldImageSize()) {
          drawing.setBackgroundFileKeyplan(keyplanUrl, {
            left: 0,
            top: 0,
            width: 1000,
            height: 650,
          });
        } else {
          // 通常はここで処理
          drawing.setBackgroundFileKeyplan(keyplanUrl);
        }
      } else {
        // printRangeがある場合がなさそうだが2020/09/29時点で判定があったのでそのままにしておく
        drawing.setBackgroundFileKeyplan(keyplanUrl, printRange);
      }
      // ツールバーボタン初期化
      ui.toolboxSelect('tool-pan');
      drawing.updateObjectCount();
    });
  } else {
    // 印刷範囲の設定(白背景)
    drawing._canvas.requestRenderAll();
    drawing.setBackgroundFileKeyplan(keyplanUrl);
    // ツールバーボタン初期化
    ui.toolboxSelect('tool-pan');
    drawing.updateObjectCount();
  }

  console.log('init_keyplan.js', 'fabric.eg.init', keyplanUrl);
  ui.correctInitKeyplanLayout();
  ui.correctLayoutFooter(false);
  window.removeEventListener(
    'resize',
    function() {
      ui.correctLayoutFooter(false);
    },
    false
  );
  window.addEventListener('resize', function() {
    ui.correctLayoutFooter(false);
  });
  // 画面遷移の警告表示
  var locationLock = true;
  $(window).on('beforeunload', function() {
    if (locationLock) {
      return '変更内容が反映されていません、編集内容か破棄されますがよろしいでしょうか?';
    }
  });

  // 印刷範囲を受信データの
  // CanvasHeight, CanvasWidth, CanvasTop, CanvasLeft が含まれる
  // オブジェクトから取得して
  // Height Width Top Left が 全て有効値
  // そして Height Width がどちらも 0 ではないなら
  // printRange を設定する。それ以外は null
  function getPrintRangeFromCanvas(CanvasData) {
    let printRange = null;
    const { CanvasHeight, CanvasWidth, CanvasTop, CanvasLeft } = CanvasData;
    if (
      [CanvasHeight, CanvasWidth, CanvasTop, CanvasLeft].every(value =>
        Number.isFinite(value)
      )
    ) {
      const height = Number(CanvasHeight);
      const width = Number(CanvasWidth);
      if (CanvasHeight !== 0 && CanvasWidth !== 0) {
        printRange = {
          height,
          width,
          top: Number(CanvasTop),
          left: Number(CanvasLeft),
        };
      }
    }
    return printRange;
  }

  $('.sys_keyplan_submit').click(function() {
    console.log('init_keyplan.js', 'sys_keyplan_submit click');

    locationLock = false;
    ui.toolboxSelect('tool-pan');
    drawing.setZoom(1);

    const saveSize = isOldImageSize()
      ? {
          width: 1000,
          height: 750,
        }
      : drawing.getBackgroundImageScaledSize();
    drawing._canvas.viewportTransform[4] = -drawing._canvas.backgroundImage
      .left;
    drawing._canvas.viewportTransform[5] = -drawing._canvas.backgroundImage.top;
    drawing._canvas.relativePan(new fabric.Point(0, 0));
    drawing._canvas.requestRenderAll();
    const imageBase64 = drawing._canvas.toDataURL(saveSize);
    delete drawing._canvas.backgroundImage;
    const objData = JSON.stringify(drawing._canvas);

    if (!getQueryStringParameter('w') || !getQueryStringParameter('h')) {
      window.opener.document.getElementById('keyplan-image').src = imageBase64;
      window.opener.document.getElementById(
        'keyplan-image-obj'
      ).value = objData;
    }
    window.opener.document.getElementById(
      'keyplan-image-val'
    ).value = imageBase64;
    window.opener.document.getElementById(
      'keyplan-image-obj-tmp'
    ).value = objData;

    // .valueにセットしても MutationObserver は変更を検知しないので属性を変更する必要がある
    // 上記の変更のタイミングを揃えるために専用のdivに属性をセット
    window.opener.document
      .getElementById('keyplan-image-changed')
      .setAttribute('isComplete', true);

    // FieldImagesKeyplan.jsx initObserve で実行されている
    // MutationObserver によって
    // WorkEdit.jsx か WorkRegister.jsx の
    // keyplanObserver 関数が呼び出される

    window.close();
  });
  /* eslint-enable prettier/prettier */
};



// WEBPACK FOOTER //
// ./src/canvas/keyPlan/init_keyplan.js